var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "langCurrCountrySwitch-modal-wrapper" } }, [
    _c(
      "div",
      {
        ref: "langCurrCountrySwitchModal",
        staticClass: "modal fade",
        attrs: {
          id: "langCurrCountrySwitchModal",
          tabindex: "-1",
          role: "dialog",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c(
              "div",
              {
                staticClass: "modal-header",
                staticStyle: { background: "#475d7d" },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "modal-title h3 w-100",
                    staticStyle: { color: "white" },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$translate(
                            "Servershop5::Template.CountryLangCurrencyPreferenceHeader"
                          )
                        ) +
                        "\n          "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    staticStyle: {
                      color: "white!important",
                      margin: "unset!important",
                    },
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-hidden": "true",
                    },
                  },
                  [_vm._v("×")]
                ),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body my-1" }, [
              _c(
                "div",
                { staticClass: "row my-2 h5" },
                [
                  _c("div", { staticClass: "col-lg col-12 my-1" }, [
                    _c("label", { attrs: { for: "currencySelect" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Servershop5::Template.switchCurrency")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedCurrency,
                            expression: "selectedCurrency",
                          },
                        ],
                        staticClass: "selectLangCurrCountry",
                        attrs: { id: "currencySelect" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedCurrency = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.filteredCurrencies, function (currency) {
                        return _c(
                          "option",
                          {
                            key: currency.name,
                            domProps: { value: currency.name },
                          },
                          [
                            _vm._v(
                              "\n                  " +
                                _vm._s(currency.name) +
                                " (" +
                                _vm._s(currency.symbol) +
                                ")\n                "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-lg col-12 my-1" }, [
                    _c("label", { attrs: { for: "languageSelect" } }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate("Servershop5::Template.switchLanguage")
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.selectedLanguage,
                            expression: "selectedLanguage",
                          },
                        ],
                        staticClass: "selectLangCurrCountry",
                        attrs: { id: "languageSelect" },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedLanguage = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      [
                        _c("option", { attrs: { value: "de" } }, [
                          _vm._v("DE"),
                        ]),
                        _vm._v(" "),
                        _c("option", { attrs: { value: "en" } }, [
                          _vm._v("EN"),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isLoggedIn
                    ? void 0
                    : [
                        _c("shipping-country-select-custom", {
                          staticClass: "col-lg col-12 my-1",
                          on: {
                            updateShippingCountryId:
                              _vm.setSelectedShippingCountry,
                          },
                        }),
                      ],
                ],
                2
              ),
              _vm._v(" "),
              _c("div", { staticClass: "row my-4" }, [
                _c(
                  "div",
                  { staticClass: "col-12", attrs: { id: "content" } },
                  [
                    _vm.selectedCurrency == "EUR" &&
                    _vm.selectedShippingCountry == 4
                      ? [
                          _vm.selectedLanguage == "de"
                            ? [
                                _vm._v(
                                  "\n                   Grüezi, Kunden aus der Schweiz! Wenn Sie die Währung CHF auswählen, erhalten Sie die Zahlungsmöglichkeit auf ein Schweizer PostFinance Konto oder via Twint sowie nach dem Kauf Ihre Rechnung ausgestellt in CHF.\n                 "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                   Grüezi, customers from Switzerland! If you select CHF as your currency, you'll have the option to pay via a Swiss PostFinance account or Twint, and your invoice will be issued in CHF after the purchase.\n                 "
                                ),
                              ],
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.selectedShippingCountry == 12
                      ? [
                          _vm.selectedLanguage == "de"
                            ? [
                                _vm._v(
                                  "\n                  Leider können wir Bestellungen nach Großbritannien erst ab einem Bestellwert von 200 EUR annehmen.\n                "
                                ),
                              ]
                            : [
                                _vm._v(
                                  "\n                  Please note that we only accept orders to the UK starting from a minimum order value of 200 EUR.\n                "
                                ),
                              ],
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-1 mt-4" }, [
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "button",
                    {
                      ref: "close",
                      staticClass: "btn btn-primary btn-block",
                      attrs: { "data-dismiss": "modal" },
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$translate("Servershop5::Template.cancelModal")
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-block btn-primary",
                      on: {
                        click: function ($event) {
                          return _vm.update()
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$translate(
                              "Servershop5::Template.updateShopSettings"
                            )
                          ) +
                          "\n              "
                      ),
                    ]
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }